import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Select from "react-select";

function ItemMaster() {
  const [formData, setFormData] = useState({
    id: "",
    store_unit: "",
    store_batch_no: "",
    store_item_name: "",
    store_department: "",
    store_hsn: "",
    store_igst: ""
  });
  const [isAdmin, setIsAdmin] = useState('');

  const [ldata, setLdata] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  // dropdown data
  const [units, setUnits] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [hsnList, setHsnList] = useState([]);

  // React Select options
  const [unitOptions, setUnitOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [hsnOptions, setHsnOptions] = useState([]);

  // Selected values for React Select
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedHsn, setSelectedHsn] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [alert, setAlert] = useState({ show: false, msg: "", type: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Save / Update
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.store_item_name) {
      toast.error("Please enter item name!");
      return;
    }

    const fd = new FormData();
    fd.append("id", formData.id);
    fd.append("store_unit", formData.store_unit);
    fd.append("store_batch_no", formData.store_batch_no);
    fd.append("store_item_name", formData.store_item_name);
    fd.append("store_department", formData.store_department);
    fd.append("store_hsn", formData.store_hsn);
    fd.append("store_igst", formData.store_igst);
    fd.append("user_id", ldata?.user_id);

    try {
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.itemSaveUrl,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data.status) {
        setAlert({ show: true, msg: response.data.success, type: "success" });
        setFormData({
          id: "",
          store_unit: "",
          store_batch_no: "",
          store_item_name: "",
          store_department: "",
          store_hsn: "",
          store_igst: "",
        });
        setSelectedUnit(null);
        setSelectedDepartment(null);
        setSelectedHsn(null);
        // Pass user_id directly so it doesn't depend on state
        getItems();
        toast.success(formData.id ? "Item updated successfully" : "Item created successfully");
      } else {
        toast.error(response.data.success || "Failed to save item");
      }
    } catch (error) {
      console.error("Save error:", error);
      toast.error("Error saving item");
    }
  };

  // Fetch all items from get_store_items API (GET, no user_id needed)
  const getItems = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        AppConst.BASE_URL + AppConst.itemListUrl
      );

      console.log("Items API response:", res.data);

      if (res.data.status) {
        const data = res.data.data || res.data.records || [];
        setItems(data);
        console.log("Items loaded:", data.length);
      } else {
        console.warn("Items API returned status false:", res.data);
        setItems([]);
      }
    } catch (error) {
      console.error("Error fetching items:", error);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  // Delete item
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure?")) return;
    const fd = new FormData();
    fd.append("id", id);
    try {
      const res = await axios.post(
        AppConst.BASE_URL + AppConst.itemDeleteUrl,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      if (res.data.status) {
        getItems();
        toast.success("Item deleted successfully");
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Edit item
  const handleEdit = (item) => {
    setFormData({
      id: item.id,
      store_unit: item.store_unit,
      store_batch_no: item.store_batch_no,
      store_item_name: item.store_item_name,
      store_department: item.store_department,
      store_hsn: item.store_hsn,
      store_igst: item.store_igst,
    });

    // Set selected values for React Select
    const unit = unitOptions.find(opt => opt.value === item.store_unit);
    const dept = departmentOptions.find(opt => opt.value === item.store_department);
    const hsn = hsnOptions.find(opt => opt.value === item.store_hsn);

    setSelectedUnit(unit || null);
    setSelectedDepartment(dept || null);
    setSelectedHsn(hsn || null);

    // Scroll to form
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Fetch dropdown data
  const getDropdownData = async () => {
    try {
      const [unitRes, depRes, hsnRes] = await Promise.all([
        axios.get(AppConst.BASE_URL + AppConst.GetAllStoreUnits),
        axios.get(AppConst.BASE_URL + AppConst.GetAllStoreDepartments),
        axios.get(AppConst.BASE_URL + AppConst.GetAllStoreHns),
      ]);

      if (unitRes.data.status) {
        setUnits(unitRes.data.list || []);
        setUnitOptions((unitRes.data.list || []).map(u => ({
          value: u.store_settings_unit_name,
          label: u.store_settings_unit_name
        })));
      }

      if (depRes.data.status) {
        setDepartments(depRes.data.list || []);
        setDepartmentOptions((depRes.data.list || []).map(d => ({
          value: d.store_settings_department,
          label: d.store_settings_department
        })));
      }

      if (hsnRes.data.status) {
        setHsnList(hsnRes.data.list || []);
        setHsnOptions((hsnRes.data.list || []).map(h => ({
          value: h.store_hsn,
          label: `${h.store_hsn} (GST: ${h.store_igst})`,
          igst: h.store_igst
        })));
      }
    } catch (err) {
      console.error("Dropdown fetch error:", err);
    }
  };

  useEffect(() => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setLdata(parsed);

      // Check admin
      if (parsed.role_id === 1 || parsed.role_id === "1") {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }

      // Fetch data — pass user_id directly from parsed (not from state)
      getDropdownData();
      getItems();
    }
  }, []);

  // DataTable Columns
  const columns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      sortable: false,
      width: "60px",
    },
    {
      name: "Unit",
      selector: (row) => row.store_unit || "-",
      sortable: true,
    },
    {
      name: "Batch",
      selector: (row) => row.store_batch_no || "-",
      sortable: true,
    },
    {
      name: "Item",
      selector: (row) => row.store_item_name || "-",
      sortable: true,
    },
    {
      name: "Department",
      selector: (row) => row.store_department || "-",
      sortable: true,
    },
    {
      name: "HSN",
      selector: (row) => row.store_hsn || "-",
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="d-flex gap-1">
          <button
            className="btn btn-sm btn-warning"
            onClick={() => handleEdit(row)}
           // disabled={!isAdmin}
            
            style={{ opacity: !isAdmin ? 0.5 : 1,width: "100px", pointerEvents: !isAdmin ? "none" : "auto" }}
            
          >
            Edit
            
          </button>
          <button
            className="btn btn-sm btn-danger"
            disabled={!isAdmin}
            style={{ opacity: !isAdmin ? 0.5 : 1,width: "100px", pointerEvents: !isAdmin ? "none" : "auto" }}
            onClick={() => handleDelete(row.id)}
          >
            Delete
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  // Filter data based on search
  const filteredItems = items.filter((it) => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase();
    return (
      (it.store_item_name || "").toLowerCase().includes(term) ||
      (it.store_hsn || "").toLowerCase().includes(term) ||
      (it.store_department || "").toLowerCase().includes(term) ||
      (it.store_batch_no || "").toLowerCase().includes(term)
    );
  });

  // Custom styles for DataTable
  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#f8f9fa",
        fontWeight: "bold",
      },
    },
    rows: {
      style: {
        minHeight: "48px",
      },
    },
  };

  // Custom styles for React Select
  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: '38px',
      borderColor: '#ced4da',
    }),
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xxl-12">
            <div className="card">
              <div className="card-body">
                <h5>Item Master</h5>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-4">
                      <label className="form-label">Unit</label>
                      <Select
                        options={unitOptions}
                        value={selectedUnit}
                        onChange={(selected) => {
                          setSelectedUnit(selected);
                          setFormData((prev) => ({
                            ...prev,
                            store_unit: selected ? selected.value : "",
                          }));
                        }}
                        isClearable
                        placeholder="Select Unit"
                        styles={selectStyles}
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label">Batch No</label>
                      <input
                        type="text"
                        className="form-control"
                        name="store_batch_no"
                        value={formData.store_batch_no}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label">Item Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="store_item_name"
                        value={formData.store_item_name}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label">Department</label>
                      <Select
                        options={departmentOptions}
                        value={selectedDepartment}
                        onChange={(selected) => {
                          setSelectedDepartment(selected);
                          setFormData((prev) => ({
                            ...prev,
                            store_department: selected ? selected.value : "",
                          }));
                        }}
                        isClearable
                        placeholder="Select Department"
                        styles={selectStyles}
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="form-label">HSN</label>
                      <Select
                        options={hsnOptions}
                        value={selectedHsn}
                        onChange={(selected) => {
                          setSelectedHsn(selected);
                          setFormData((prev) => ({
                            ...prev,
                            store_hsn: selected ? selected.value : "",
                            store_igst: selected ? selected.igst : "",
                          }));
                        }}
                        isClearable
                        placeholder="Select HSN"
                        styles={selectStyles}
                      />
                      <input type="hidden" name="store_igst" value={formData.store_igst || ""} />
                    </div>

                    <div className="col-12 mt-3 text-end">
                      {formData.id && (
                        <button
                          type="button"
                          className="btn btn-secondary me-2"
                          onClick={() => {
                            setFormData({ id: "", store_unit: "", store_batch_no: "", store_item_name: "", store_department: "", store_hsn: "", store_igst: "" });
                            setSelectedUnit(null);
                            setSelectedDepartment(null);
                            setSelectedHsn(null);
                          }}
                        >
                          Cancel Edit
                        </button>
                      )}
                      <button type="submit" className="btn btn-primary">
                        {formData.id ? "Update" : "Save"}
                      </button>
                    </div>
                  </div>
                </form>

                <hr />

                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6>Item List ({filteredItems.length})</h6>
                  <div className="col-4">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by Item, HSN, Department, Batch"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>

                <DataTable
                  columns={columns}
                  data={filteredItems}
                  pagination
                  paginationPerPage={10}
                  paginationRowsPerPageOptions={[10, 20, 30, 50]}
                  highlightOnHover
                  striped
                  responsive
                  customStyles={customStyles}
                  progressPending={loading}
                  noDataComponent="No items found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ItemMaster;